
import React  from 'react';

const AddFuel = () => {
    return (
        <div>Add fuel</div>
    )
}

export default AddFuel;